module.exports = __webpack_public_path__ + "img/sixpackcarrier40.a8f3ec78.jpg";